import { Box, Paper, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const ImposterRulesStep: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const neonPalette = (theme.palette as any).neon;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `4px solid ${neonPalette.purple}`,
        borderRadius: 3,
        boxShadow: `0 8px 32px ${neonPalette.purple}60, 0 4px 16px ${neonPalette.purple}30, inset 0 0 20px ${neonPalette.purpleLight}20`,
        overflow: "visible",
      }}
    >
      <Box sx={{ p: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            textAlign: "center",
            mb: 4,
            background: `linear-gradient(135deg, ${neonPalette.purple} 0%, ${neonPalette.pink} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          {t("imposter.rules")}
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: neonPalette.purpleLight,
              border: `2px solid ${neonPalette.purple}`,
              borderRadius: 2,
              boxShadow: `0 2px 8px ${neonPalette.purple}30`,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                lineHeight: 1.8,
                fontWeight: 500,
              }}
            >
              {t("imposter.rule1")}
            </Typography>
          </Paper>
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: neonPalette.cyanLight,
              border: `2px solid ${neonPalette.cyan}`,
              borderRadius: 2,
              boxShadow: `0 2px 8px ${neonPalette.cyan}30`,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                lineHeight: 1.8,
                fontWeight: 500,
              }}
            >
              {t("imposter.rule2")}
            </Typography>
          </Paper>
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: neonPalette.blueLight,
              border: `2px solid ${neonPalette.blue}`,
              borderRadius: 2,
              boxShadow: `0 2px 8px ${neonPalette.blue}30`,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                lineHeight: 1.8,
                fontWeight: 500,
              }}
            >
              {t("imposter.rule3")}
            </Typography>
          </Paper>
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: neonPalette.yellowLight,
              border: `2px solid ${neonPalette.yellow}`,
              borderRadius: 2,
              boxShadow: `0 2px 8px ${neonPalette.yellow}30`,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                lineHeight: 1.8,
                fontWeight: 500,
              }}
            >
              {t("imposter.rule4")}
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Paper>
  );
};

export default ImposterRulesStep;
